import { Component, OnInit } from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

@Component({
  selector: "app-bar-chart",
  templateUrl: "./bar-chart.component.html",
  styleUrls: ["./bar-chart.component.scss"],
})
export class BarChartComponent implements OnInit {
  chart: any;
  constructor() {}

  ngOnInit(): void {
    let chart = am4core.create("chartdiv", am4charts.XYChart);
    this.chart = chart;
    chart.logo.height = -1500;
    // Add data
    chart.data = [
      {
        country: "Lithuania",
        litres: 501.9,
        units: 250,
      },
      {
        country: "Czech Republic",
        litres: 301.9,
        units: 222,
      },
      {
        country: "Ireland",
        litres: 201.1,
        units: 170,
      },
      {
        country: "Germany",
        litres: 165.8,
        units: 122,
      },
      {
        country: "Australia",
        litres: 139.9,
        units: 99,
      },
      {
        country: "Austria",
        litres: 128.3,
        units: 85,
      },
      {
        country: "UK",
        litres: 99,
        units: 93,
      },
      {
        country: "Belgium",
        litres: 60,
        units: 50,
      },
      {
        country: "The Netherlands",
        litres: 50,
        units: 42,
      },
    ];

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "country";
    categoryAxis.title.text = "Countries";

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "Litres sold (M)";

    // Create series
    let series = chart.series.push(new am4charts.ColumnSeries());
    series.tooltip.label.interactionsEnabled = true;
    series.tooltip.keepTargetHover = true;
    series.dataFields.valueY = "litres";
    series.dataFields.categoryX = "country";
    series.name = "Sales";

    //bars color
    series.columns.template.fill = am4core.color("#104547");

    //simple tooltip text
    // series.columns.template.tooltipText =
    //   "Series: {name}\nCategory: {categoryX}\nValue: {valueY}";

    // series.adapter.add('tooltipText', (text, target: LineSeriesDataItem) => {
    // });
    // var series2 = chart.series.push(new am4charts.LineSeries());
    // series2.name = "Units";
    // series2.stroke = am4core.color("#CDA2AB");
    // series2.strokeWidth = 3;
    // series2.dataFields.valueY = "units";
    // series2.dataFields.categoryX = "country";

    series.tooltip.autoTextColor = false;
    //color of tooltip text and its background
    series.tooltip.label.background.fill = am4core.color("#9fcfd1");
    series.tooltip.label.fill = am4core.color("#ffffff");

    //tooltipHTML with link
    series.columns.template.tooltipHTML =
      '<b>Series: {name},\nCategory: {categoryX},\nValue: {valueY}</b> <br> <a href="https://en.wikipedia.org/wiki/{category.urlEncode()}" target="_blank">More info</a>';
  }

  ngOnDestroy() {
    // Clean up chart when the component is removed
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
